import Text from '@components/Text';
import { Button, ButtonGroup, CircularProgress } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import * as React from 'react';

export enum ButtonSaveType {
    SAVE_AND_ADD = 'SAVE_AND_ADD',
    SAVE_AND_RETURN = 'SAVE_AND_RETURN',
}

const options = [ButtonSaveType.SAVE_AND_RETURN, ButtonSaveType.SAVE_AND_ADD];

type Props = {
    onClick?: any;
    onChange?: (type: ButtonSaveType) => void;
    loading?: boolean;
    disabled?: boolean;
    labels?: {
        [key in ButtonSaveType]: string;
    };
};

const ButtonSaveSplit = (props: Props) => {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLDivElement>(null);
    const [selectedIndex, setSelectedIndex] = React.useState(0);

    const handleClick = () => {
        props.onClick?.(options[selectedIndex]);
    };

    const handleMenuItemClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>, index: number) => {
        setSelectedIndex(index);
        props.onChange?.(options[index]);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen(prevOpen => !prevOpen);
    };

    const handleClose = (event: Event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
            return;
        }

        setOpen(false);
    };

    return (
        <React.Fragment>
            <ButtonGroup variant="contained" ref={anchorRef} aria-label="split button">
                <Button onClick={handleClick} disabled={props.disabled}>
                    {props.loading ? (
                        <CircularProgress size="small" />
                    ) : (
                        <i className="fi fi-br-check" style={{ marginRight: 8 }} />
                    )}
                    {props.labels[options[selectedIndex]]}
                </Button>
                <Button
                    aria-controls={open ? 'split-button-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={handleToggle}>
                    <i className="fi fi-rr-angle-down" style={{ fontSize: 12 }} />
                </Button>
            </ButtonGroup>
            <Popper
                sx={{
                    zIndex: 5,
                }}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal>
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                        }}>
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList id="split-button-menu" autoFocusItem>
                                    {options.map((option, index) => (
                                        <MenuItem
                                            style={{
                                                padding: '8px 24px',
                                            }}
                                            key={option}
                                            disabled={index === 2}
                                            selected={index === selectedIndex}
                                            onClick={event => handleMenuItemClick(event, index)}>
                                            <Text dark>{props.labels[option]}</Text>
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </React.Fragment>
    );
};

export default ButtonSaveSplit;
